import { Observable } from 'rxjs';
import { IFeatureFlags } from '@domain/interfaces/feature-flags/feature-flags.interface';

export abstract class FeatureFlagsGateway {
  abstract refresh(): Observable<IFeatureFlags>;
  abstract isEnabled(key: string): Observable<boolean>;
  abstract getAllFlags(): Observable<IFeatureFlags>;
}
